/**
 * @generated SignedSource<<0a1c88ca4a42ad82ed80e88345c91c0b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionWriteFragment$data = {
  readonly by: {
    readonly displayName: string | null | undefined;
  } | null | undefined;
  readonly when: string | null | undefined;
  readonly " $fragmentType": "useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionWriteFragment";
};
export type useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionWriteFragment$key = {
  readonly " $data"?: useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionWriteFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionWriteFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionWriteFragment",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "by",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "displayName"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "when"
    }
  ],
  "type": "Version"
};

(node as any).hash = "f2546d473e081d7f407ad1cb2c10a7c2";

export default node;
